import { $t } from '@/plugins/i18n';
const StringLength = {
  fixedLengthTwo: {
    min: 2,
    max: 2,
    message: $t('限2个字符'),
    trigger: ['blur', 'change']
  },
  lengthTwo: {
    min: 0,
    max: 2,
    message: $t('限2个字符内'),
    trigger: ['blur', 'change']
  },
  lengthFour: {
    min: 0,
    max: 4,
    message: $t('限4个字符内'),
    trigger: ['blur', 'change']
  },
  lengthFive: {
    min: 0,
    max: 5,
    message: $t('限5个字符内'),
    trigger: ['blur', 'change']
  },
  lengthSix: {
    min: 0,
    max: 6,
    message: $t('限6个字符内'),
    trigger: ['blur', 'change']
  },
  lengthEight: {
    min: 0,
    max: 8,
    message: $t('限8个字符内'),
    trigger: ['blur', 'change']
  },
  lengthTen: {
    min: 0,
    max: 10,
    message: $t('限10个字符内'),
    trigger: ['blur', 'change']
  },
  lengthEleven: {
    min: 0,
    max: 11,
    message: $t('限11个字符内'),
    trigger: ['blur', 'change']
  },
  lengthTwelve: {
    min: 0,
    max: 12,
    message: $t('限12个字符内'),
    trigger: ['blur', 'change']
  },
  lengthFifteen: {
    min: 0,
    max: 15,
    message: $t('限15个字符内'),
    trigger: ['blur', 'change']
  },
  lengthEighteen: {
    min: 0,
    max: 18,
    message: $t('限18个字符内'),
    trigger: ['blur', 'change']
  },
  lengthTwenty: {
    min: 0,
    max: 20,
    message: $t('限20个字符内'),
    trigger: ['blur', 'change']
  },
  lengthTwentyFive: {
    min: 0,
    max: 25,
    message: $t('限25个字符内'),
    trigger: ['blur', 'change']
  },
  lengthThirty: {
    min: 0,
    max: 30,
    message: $t('限30个字符内'),
    trigger: ['blur', 'change']
  },
  lengthfifty: {
    min: 0,
    max: 50,
    message: $t('限50个字符内'),
    trigger: ['blur', 'change']
  },
  lengthThirtytwo: {
    min: 0,
    max: 32,
    message: $t('限32个字符内'),
    trigger: ['blur', 'change']
  },
  lengthFourty: {
    min: 0,
    max: 40,
    message: $t('限40个字符内'),
    trigger: ['blur', 'change']
  },
  lengthFifty: {
    min: 0,
    max: 50,
    message: $t('限50个字符内'),
    trigger: ['blur', 'change']
  },
  lengthSixty: {
    min: 0,
    max: 60,
    message: $t('限60个字符内'),
    trigger: ['blur', 'change']
  },
  lengthEighty: {
    min: 0,
    max: 80,
    message: $t('限80个字符内'),
    trigger: ['blur', 'change']
  },
  lengthOneHundred: {
    min: 0,
    max: 100,
    message: $t('限100个字符内'),
    trigger: ['blur', 'change']
  },
  lengthTwoHundred: {
    min: 0,
    max: 200,
    message: $t('限200 个字符内'),
    trigger: ['blur', 'change']
  },
  lengTwoThousandFifty: {
    min: 0,
    max: 250,
    message: $t('限250个字符内'),
    trigger: ['blur', 'change']
  },
  lengthFiveHd: {
    min: 0,
    max: 500,
    message: $t('限500个字符内'),
    trigger: 'blur'
  },
  lengTwoThousand: {
    min: 0,
    max: 2000,
    message: $t('限2000个字符内'),
    trigger: ['blur', 'change']
  }
};
// 初始化规则
export const RULES = {
  ...StringLength,
  required: {
    required: true,
    message: $t('请输入'),
    trigger: ['blur', 'change']
  },
  requiredOptions: {
    required: true,
    message: $t('请选择'),
    trigger: ['blur', 'change']
  },
  requiredSearch: {
    required: true,
    message: $t('请搜索后选择'),
    trigger: ['blur', 'change']
  },
  ...{
    email: { validator: email, trigger: ['blur', 'change'] }, // 邮箱
    lengthNine: {
      min: 0,
      max: 9,
      message: $t('限9个字符内'),
      trigger: ['blur', 'change']
    },
    int500: { validator: int500, trigger: ['blur', 'change'] },
    vehiclePlateNumber: {
      validator: vehiclePlateNumber,
      trigger: ['blur', 'change']
    }, // 车牌号
    priceNum: { validator: priceNum, trigger: ['blur', 'change'] }, // 车牌号
    axleNumber: { validator: axleNumber, trigger: ['blur', 'change'] }, // 车轴数
    or0and1: { validator: or0and1, trigger: ['blur', 'change'] }, // 车轴数
    carCount: { validator: carCount, trigger: ['blur', 'change'] }, // 自有车数量
    landlineCellphone: {
      validator: landlineCellphone,
      trigger: ['blur', 'change']
    }, // 座机号 + 手机号
    bankNo: { validator: bankNo, trigger: ['blur', 'change'] }, // 银行账号
    fiftyNum: { validator: fiftyNum, trigger: ['blur', 'change'] }, // 银行账号
    reditCode: { validator: reditCode, trigger: ['blur', 'change'] }, // 统一社会信用代码
    int99: { validator: int99, trigger: ['blur', 'change'] }, // 0-99正整数
    chePlateNumber: {
      validator: chePlateNumber,
      trigger: ['blur', 'change']
    }, // 印尼车牌-校验规则：【1-2位】大写英文字母【1-4位】数字【0-3位】英文字母
    chePhone: { validator: chePhone, trigger: ['blur', 'change'] }, // 手机号-校验规则: 10位数字
    elevenNum: {
      min: 11,
      max: 11,
      message: $t('限11个字符'),
      trigger: ['blur', 'change']
    }, // 限制 11位
    flightCode: { validator: flightCode, trigger: ['blur', 'change'] },
    isPureNumber: { validator: isPureNumber, trigger: ['blur', 'change'] },
    timeRules: { validator: timeValidator, trigger: ['blur', 'change'] },
    mileage: { validator: mileage, trigger: ['blur', 'change'] },
    num11: { validator: num11, trigger: ['blur', 'change'] },
    lengthThreeHundred: {
      min: 0,
      max: 300,
      message: $t('限300 个字符内'),
      trigger: ['blur', 'change']
    },
    moneyNumber2: { validator: moneyNumber2, trigger: ['blur', 'change'] }, // 100000
    priceEightTwo: { validator: priceEightTwo, trigger: ['blur', 'change'] }, // 八位数字加小数两位
    codeStrikeGang: { validator: codeStrikeGang, trigger: ['blur', 'change'] }, // 数字加-
    numTwo: { validator: numTwo, trigger: ['blur', 'change'] }, // 小数后两位
    tenNumberCode: { validator: tenNumberCode, trigger: ['blur', 'change'] }, // 10位以下数字字母任意组合-
    lengthOneHundredAndFifty: {
      min: 0,
      max: 150,
      message: $t('限150个字符内'),
      trigger: ['blur', 'change']
    },
    lengthOneHdAndFifty: {
      min: 0,
      max: 150,
      message: $t('限150个字符内'),
      trigger: 'blur'
    },
    twentyVits2: { validator: twentyVits2, trigger: ['blur', 'change'] }, // 整数20 小数两位
    lengOnehousand: {
      min: 0,
      max: 1000,
      message: $t('限1000个字符内'),
      trigger: ['blur', 'change']
    },
    numSix: { validator: numSix, trigger: ['blur', 'change'] },
    nineNum: { validator: nineNum, trigger: ['blur', 'change'] },
    tenNum: { validator: tenNum, trigger: ['blur', 'change'] },
    twentyNum: { validator: twentyNum, trigger: ['blur', 'change'] },
    thirtyNum: { validator: thirtyNum, trigger: ['blur', 'change'] },
    lengthEightToSixteen: {
      min: 8,
      max: 16,
      message: $t('长度在8-16个字符'),
      trigger: ['blur', 'change']
    },
    lengthThiryFivety: {
      min: 30,
      lengthFiveHd: 50,
      message: $t('长度在30-50个字符'),
      trigger: ['blur', 'change']
    },
    upperCaseNum: { validator: upperCaseNum, trigger: ['blur', 'change'] }, // 字符数字
    noNumber: { validator: noNumber, trigger: ['blur', 'change'] }, // 不能全数字
    isNumber: { validator: isNumber, trigger: ['blur', 'change'] }, // 数字
    numberAndString: {
      validator: numberAndString,
      trigger: ['blur', 'change']
    }, // 字符数字
    requestNumber: { validator: requestNumber, trigger: ['blur', 'change'] }, // 字符数字
    isStringNumber: { validator: isStringNumber, trigger: ['blur', 'change'] }, // 字符数字 @careful 这里使用的是code的正则
    connectNumber: { validator: connectNumber, trigger: ['blur', 'change'] }, // 数字和连接符
    chString: { validator: chString, trigger: ['blur', 'change'] }, //
    enString: { validator: enString, trigger: ['blur', 'change'] }, //
    chEnNumString: { validator: chEnNumString, trigger: ['blur', 'change'] }, // 中文英文数字
    enString50: { validator: enString50, trigger: ['blur', 'change'] }, //
    enString60: { validator: enString60, trigger: ['blur', 'change'] }, //
    integer: { validator: integer, trigger: ['blur', 'change'] }, // 大于等于0整数
    negative: { validator: negative, trigger: ['blur', 'change'] }, // 可以为负数
    integer99999999999: {
      validator: integer99999999999,
      trigger: ['blur', 'change']
    },
    decimalLessthanOne: {
      validator: decimalLessthanOne,
      trigger: ['blur', 'change']
    }, // 不大于等于1
    moreZeroInteger: {
      validator: moreZeroInteger,
      trigger: ['blur', 'change']
    }, // 大于0整数
    floatingNum: { validator: floatingNum, trigger: ['blur', 'change'] }, // 大于0浮点数
    threeCode: { validator: threeCode, trigger: ['blur', 'change'] }, // 三字码
    zipcode: { validator: zipcode, trigger: ['blur', 'change'] }, // 邮编验证
    areaNo: { validator: areaNo, trigger: ['blur', 'change'] }, // 区号验证
    bankCard: { validator: bankCard, trigger: ['blur', 'change'] }, // 银行卡验证
    isLatitude: {
      validator: latitudeANDlongitude,
      trigger: ['blur', 'change']
    }, // 纬度,经度
    numTwoFloat: { validator: numTwoFloat, trigger: ['blur', 'change'] }, // 小数后两位
    number_letter: { validator: number_letter, trigger: ['blur', 'change'] }, // 10位数字、字母或者下划线
    maxFourNum: { validator: maxFourNum, trigger: ['blur'] }, // 数字9999
    maxFiveNum: { validator: maxFiveNum, trigger: ['blur'] }, // 数字99999
    maxFiveNumber: { validator: maxFiveNumber, trigger: ['blur'] }, // 数字0-99999
    maxFiveAndTenThousand: {
      validator: maxFiveAndTenThousand,
      trigger: ['blur', 'change']
    }, //  5000 —— 10000
    stopSellTime: { validator: stopSellTime, trigger: ['blur'] }, // 数字999
    oneHourTime: { validator: oneHourTime, trigger: ['blur'] }, // 数字 3600
    maxTwoNum: { validator: maxTwoNum, trigger: ['blur'] }, // 数字99
    maxOneNum: { validator: maxOneNum, trigger: ['blur'] }, // 数字99
    limitNumber30: { validator: limitNumber30, trigger: ['blur', 'change'] }, // 数字最大30
    max99999: { validator: max99999, trigger: ['blur'] }, // 数字最大99999
    codeSix: { validator: codeSix, trigger: ['blur', 'change'] }, // 6位数字或者字母
    codeTen: { validator: codeTen, trigger: ['blur', 'change'] }, // 10位数字或者字母
    codeNineteen: { validator: codeNineteen, trigger: ['blur', 'change'] }, // 19位数字或者字母
    carNumber: { validator: carNumber, trigger: ['blur', 'change'] },
    int4Fload2: { validator: int4Fload2, trigger: ['blur', 'change'] },
    int2Fload2: { validator: int2Fload2, trigger: ['blur', 'change'] },
    int5Fload2: { validator: int5Fload2, trigger: ['blur', 'change'] },
    int6Fload2: { validator: int6Fload2, trigger: ['blur', 'change'] },
    time: { validator: time, trigger: ['blur', 'change'] },
    payPass: { validator: payPass, trigger: ['blur', 'change'] },
    eightNum: { validator: eightNum, trigger: ['blur', 'change'] },
    max1000000000: { validator: max1000000000, trigger: ['blur'] },
    max160: { validator: max160, trigger: ['blur', 'change'] },
    numOneFloat: { validator: numOneFloat, trigger: ['blur', 'change'] },
    numOneTwo: { validator: numOneTwo, trigger: ['blur', 'change'] },
    numOneInt: { validator: numOneInt, trigger: ['blur', 'change'] },
    numOneToFourInt: {
      validator: numOneToFourInt,
      trigger: ['blur', 'change']
    },
    max99999Int: { validator: max99999Int, trigger: ['blur', 'change'] },
    int8lastP: { validator: int8lastP, trigger: ['blur', 'change'] },
    int0or1: { validator: int0or1, trigger: ['blur', 'change'] }, // 只能是 0 or 1
    int200: { validator: int200, trigger: ['blur', 'change'] },
    maxOneThousandNum: {
      validator: maxOneThousandNum,
      trigger: ['blur', 'change']
    }, // 数字0-1000
    int2Fload3: { validator: int2Fload3, trigger: ['blur', 'change'] },
    int15to18: { validator: int15to18, trigger: ['blur', 'change'] }, // 15位或者18位
    noBlankSpace: { validator: noBlankSpace, trigger: ['blur', 'change'] }, // 不能有空格
    percentFloat: { validator: percentFloat, trigger: ['blur', 'change'] },
    lengOneThousand: {
      min: 0,
      max: 1000,
      message: $t('限1000个字符内'),
      trigger: ['blur', 'change']
    },
    plateNumber: {
      min: 6,
      max: 7,
      message: $t('限6到7个字符内'),
      trigger: ['blur', 'change']
    },
    receiverName: { validator: receiverName, trigger: ['blur', 'change'] }, // 收款人名称
    account: { validator: account, trigger: ['blur', 'change'] },
    tenNumDecimal: { validator: tenNumDecimal, trigger: ['blur', 'change'] },
    int11Fload3: { validator: int11Fload3, trigger: ['blur', 'change'] },
    int11Fload2: { validator: int11Fload2, trigger: ['blur', 'change'] },
    int14Fload2: { validator: int14Fload2, trigger: ['blur', 'change'] }, // 数字，15位，允许三位小数
    tenInterAnd2String: {
      validator: tenInterAnd2String,
      trigger: ['blur', 'change']
    }, // // 整数10+小数2位
    tenInterAnd3String: {
      validator: tenInterAnd3String,
      trigger: ['blur', 'change']
    }, // // 整数10+小数3位
    sevenInterAnd3String: {
      validator: sevenInterAnd3String,
      trigger: ['blur', 'change']
    }, // // 整数7+小数3位
    int20Fload2: { validator: int20Fload2, trigger: ['blur', 'change'] }, // 数字，20位，允许三位小数
    waybillNoRule: { validator: waybillNoRule, trigger: ['blur', 'change'] }, // 运单号：YDPH 开头，一共18位
    int15Fload2: { validator: int15Fload2, trigger: ['blur', 'change'] }, // 数字，15位，允许三位小数
    int16Fload3: { validator: int16Fload3, trigger: ['blur', 'change'] }, // 数字，16位，允许三位小数
    int10Fload2: { validator: int10Fload2, trigger: ['blur', 'change'] },
    int999999: { validator: int999999, trigger: ['blur', 'change'] }, // 数字最大999999
    sixInterAnd2String: {
      validator: sixInterAnd2String,
      trigger: ['blur', 'change']
    }, // 数字 6位整数，2位小数
    NonChinese: { validator: NonChinese, trigger: ['blur', 'change'] } //  /[\u4E00-\u9FA5]/g
  }
};

export const VALIDATION = {
  ...{
    email: {
      value:
        // eslint-disable-next-line no-useless-escape
        /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,
      label: $t('输入的邮箱格式不正确')
    },
    codeStrikeGang: {
      // 'value': /^(?=\d+.?\d*$)[\d.]{0,11}$/,
      // eslint-disable-next-line no-useless-escape
      value: /^([=0-9\-]{1,})$/,
      label: $t('数字或‘-’的组合')
    },
    numTwo: {
      value: /^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/i,
      label: $t('请保留两位小数')
    },
    num11: {
      // 'value': /^(?=\d+.?\d*$)[\d.]{0,11}$/,
      value: /^[0-9]{0,9}$/,
      label: $t('最大数值为9位数字')
    },
    max15Len: {
      required: true,
      max: 15,
      message: $t('只能填15个字符'),
      trigger: ['blur', 'change']
    },
    mileage: {
      value: /^0\.([0-9]|\d[0-9])$|^[0-9]\d{0,4}\.\d{0,2}$|^[0-9]\d{0,4}$/,
      label: $t('最大数值为5位整数+2位小数')
    },
    flightCode: {
      value: /^(?!^\d+$)(?!^[A-Z]+$)[A-Z0-9]{0,7}$/,
      label: $t('限制0-7字符,大写字母、数字')
    },
    int500: {
      value: /^(500|[1-4][0-9][0-9]|[1-9][0-9]|[1-9])$/i,
      label: $t('1-500的正整数')
    },
    vehiclePlateNumber: {
      value: /^[\u4e00-\u9fa5]{1}[A-Z0-9]{6,7}$/i,
      label: $t('车牌号码格式不正确')
    },
    priceNum: {
      value: /^0\.([0-9]|\d[0-9])$|^[0-9]\d{0,8}\.\d{0,2}$|^[0-9]\d{0,8}$/,
      label: $t('最大数值为9位整数+2位小数')
    },
    axleNumber: {
      value: /^[0-9]{1}$/i,
      label: $t('0-9的整数')
    },
    or0and1: {
      value: /^(0|1)$/i,
      label: $t('只能0或者1')
    },
    carCount: {
      value: /^[0-9]\d{0,5}$/i,
      label: $t('0-999999的整数')
    },
    landlineCellphone: {
      // eslint-disable-next-line no-useless-escape
      value: /^[[\d\-]{1,50}$/i,
      label: $t('请输入正确的手机号或者座机号')
    },
    bankNo: {
      value: /^[[\d]{1,30}$/i,
      label: $t('限30个字符内的数字')
    },
    fiftyNum: {
      value: /^[[\d]{1,50}$/i,
      label: $t('限50个字符内的数字')
    },
    reditCode: {
      value:
        /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
      label: $t('统一社会信用代码格式不正确')
    },
    int99: {
      value: /^[0-9]\d{0,1}$/i,
      label: $t('0-99的整数')
    },
    /* 印尼车牌-校验规则：【1-2位】大写英文字母【1-4位】数字【0-3位】英文字母 */
    chePlateNumber: {
      value: /^[A-Z]{1,2}\d{1,4}[A-Za-z]{0,3}$/,
      label: $t('车牌格式不正确')
    },
    /* 手机号-校验规则: 10位数字 */
    chePhone: {
      value: /^\d{10}$/,
      label: $t('请输入10位数字')
      // value: /^\d{9,16}$/,
      // label: $t('请输入9-16位数字')
    },
    /* 校验纯数字 */
    pureNumber: {
      value: /^[0-9]+$/,
      label: $t('请输入数字')
    },
    // 大写英文或数字或-_
    moneyNumber2: {
      value: /^(?!0+(\.0*)?$)\d{0,5}(\.\d{1,2})?$/i,
      label: $t('小于100000的数字,最多两位小数')
    },
    // 8位整数+2位小数
    priceEightTwo: {
      value: /^((-)?\d{1,8})(\.\d{1,2})?$/,
      label: $t('最大数值为8位整数+2位小数')
    },
    // 10位以下数字字母任意组合
    tenNumberCode: {
      value: /^[A-Za-z0-9]{1,10}$/,
      label: $t('10位以下数字字母任意组合')
    },
    twentyVits2: {
      value: /^((-)?\d{1,20})(\.\d{1,2})?$/,
      label: $t('请保留两位小数')
    },
    numSix: {
      value: /^\d{1,6}$/,
      label: $t('最大数值为6位数字')
    },
    nineNum: {
      value: /^\d{0,9}$/,
      label: $t('限9个字符内的数字')
    },
    tenNum: {
      value: /^\d{0,10}$/,
      label: $t('限10个字符内的数字')
    },
    twentyNum: {
      value: /^\d{0,20}$/,
      label: $t('限20个字符内的数字')
    },
    thirtyNum: {
      value: /^\d{0,30}$/,
      label: $t('限30个字符以内的数字')
    },
    carrierPassword: {
      value: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/,
      label: $t(
        '输入必须包含字母、数字、大小写、特殊符号两种以上，最少8位，最多20位'
      )
    },
    int6Fload2: {
      value: /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,5}\.\d{0,2}$|^[1-9]\d{0,5}$/,
      label: $t('最大数值为6位整数+2位小数')
    },
    int5Fload2: {
      value: /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,4}\.\d{0,2}$|^[1-9]\d{0,4}$/,
      label: $t('最大数值为5位整数+2位小数')
    },
    int4Fload2: {
      value: /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,3}\.\d{0,2}$|^[1-9]\d{0,3}$/,
      label: $t('最大数值为4位整数+2位小数')
    },
    int2Fload2: {
      value: /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,1}\.\d{0,2}$|^[1-9]\d{0,1}$/,
      label: $t('最大数值为2位整数+2位小数')
    },
    payPass: {
      value: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,32}$/,
      label: $t('字母，数字，特殊符号8-32位，必须包含数字和字母')
    },
    eightNum: {
      value: /^([0-9]{1,8})$/,
      label: $t('限8个字符内的数字')
    },
    numberAndString: {
      value: /^(?=[a-zA-Z]*[0-9])(?=[0-9]*[a-zA-Z])[a-zA-Z0-9]{2,}$/,
      label: $t('至少有一个英文和数字')
    },
    requestNumber: {
      value: /(.*)?\d+(.*)?$/,
      label: $t('至少有一个数字')
    },
    code: {
      value: /^([a-zA-Z0-9]{1,})$/,
      label: $t('英文和数字的组合')
    },
    contactPerson: {
      value: /^([a-zA-Z\u4e00-\u9fa5]{2,})$/,
      label: $t('2 - 10位的英文或汉字')
    },
    roleName: {
      value: /^([a-zA-Z\u4e00-\u9fa5]{2,10})$/,
      label: $t('长度在2-10个字符的英文或汉字')
    },
    codeName: {
      value: /^([a-zA-Z0-9_]{1,10})$/,
      label: $t('限10个字符内的英文或数字')
    },
    limitNumber30: {
      value: 30,
      label: $t('请输入不大于30的数字')
    },
    codeName15: {
      value: /^([a-zA-Z0-9_]{1,15})$/,
      label: $t('限15个字符内的字母或数字')
    },
    character: {
      value: /^.{1,100}$/,
      label: $t('输入正确的字符长度')
    },
    chMobile: {
      value: /^1[3|4|5|7|8][0-9]\d{8,8}$/,
      label: $t('输入的手机号码格式不正确')
    },
    phoneAndChMobile: {
      value: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
      label: $t('输入的电话或手机号码格式不正确')
    },
    company: {
      value: /.*/i,
      label: $t('输入的名称格式不正确')
    },
    address: {
      value: /.*/i,
      label: $t('输入的地址格式不正确')
    },
    zipcode: {
      value: /^[0-9]\d{0,10}$/i,
      label: $t('限10个字符内的数字')
    },
    areaNo: {
      value: /^[0-9]\d{0,5}$/i,
      label: $t('限5个字符内的数字')
    },
    date: {
      value: /^(\d{4})-(\d{2})-(\d{2})$/i,
      label: $t('日期格式为：yyyy-mm-dd，如2015-01-01')
    },
    time: {
      value: /^(\d{4})-(\d\d)-(\d\d) (\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/i,
      label: $t('时间格式为：yyyy-mm-dd hh:mm:ss或hh:mm，如2008-08-08 18:00')
    },
    price: {
      value: /^([1-9]?[0-9]{1,5})(\.[0-9]{1,2})?$/,
      label: $t('数字x元x毛x分，格式为：xx、xx.xx、x.xx')
    },
    ticketPrice: {
      value: /^([1-9]?[0-9]{0,2})(\.[0-9]{1,2})?$/,
      label: $t('数字:1-999.99')
    },
    coupon: {
      value: /^([1-9][0-9]{0,1})$/,
      label: $t('数字:1-99')
    },
    maxOneNum: {
      value: /^([0-9]{0,1})$/,
      label: $t('数字:0-9')
    },
    carNumber: {
      value: /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z0-9]{5}$/i,
      label: $t('车牌号码格式不正确')
    },
    percent: {
      value: /^(0|[1-9][0-9]{0,3})(\.[0-9]{1,2})?%$/i,
      label: $t('xxxx.xx%，如123.45%')
    },
    numTwoFloat: {
      value: /^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/i,
      label: $t('小数点后两位')
    },
    integer: {
      value: /^(0|[1-9][0-9]*)$/i,
      label: $t('请输入大于等于0的整数')
    },
    floatingNum: {
      value: /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/i,
      label: $t('请输入大于0并保留两位小数点的数字')
    },
    moreZeroInteger: {
      value: /^([1-9][0-9]*)$/i,
      label: $t('请输入大于0的整数')
    },
    moreZeroFloat: {
      value: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
      label: $t('请输入大于0的数字')
    },
    number: {
      value: /^\d{1,2}$/i,
      label: $t('两位数字')
    },
    specialTicket: {
      value: /^\d{1,2}$/i,
      label: $t('1-2位数字')
    },
    specialTicketPrice: {
      value: /^([0-9]{1,3})+([.]{1}[0-9]+){0,1}$/i,
      label: $t('金额为:1-300')
    },
    cnaps: {
      value: /^\d{12}$/,
      label: $t('格式为：12位数字')
    },
    upperCase: {
      value: /^[A-Z]+$/i,
      label: $t('格式为：英文大写字母')
    },
    lowerCase: {
      value: /^[a-z]+$/i,
      label: $t('格式为：英文小写字母')
    },
    letter: {
      value: /^[A-Za-z]+$/i,
      label: $t('格式为：英文大小写')
    },
    string: {
      value: /.*/i,
      label: $t('输入非法字符')
    },
    license: {
      value:
        /(^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{6}$)|(^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$)/i,
      label: $t('格式为：首位中文、大写英文、数字加英语')
    },
    chString: {
      value: /^[\u4e00-\u9fa5]+$/i,
      label: $t('中文字符')
    },
    enString: {
      value: /^[A-Za-z\s·]+$/i,
      label: $t('必须是英文字符')
    },
    chEnString: {
      value: /^([\u4e00-\u9fa5A-Za-z\s]+)$/i,
      label: $t('格式为：中英文字符')
    },
    chEnNumString: {
      value: /^([\u4e00-\u9fa5A-Za-z0-9\s]+)$/i,
      label: $t('格式为：中英文数字字符')
    },
    search: {
      value: /^.{0,12}$/i,
      label: $t('输入的搜索信息格式不正确，最多支持12个字符')
    },
    threeDigit: {
      value: /^[1-9]\d{0,2}$/i,
      label: $t('位数不能超过三位数')
    },
    vName: {
      value:
        /(^[0-9]{0,2}\.[0-9]{0,2}\.[0-9]{0,2}\.[1-9]{0,4}$)|(^[0-9]{0,2}$)|(^[0-9]{0,2}\.[0-9]{0,2}$)|(^[0-9]{0,2}\.[0-9]{0,2}\.[,0-9]{0,2}$)/i,
      label: $t('输入格式错误')
    },
    loginName: {
      value: /^[\w]{6,16}$/,
      label: $t('格式为：6-16位英文大小写、数字、下划线_')
    },
    bankCard: {
      value: /^(\d{16}$)|(^\d{17}$)|(^\d{18}$)|(^\d{19}$)/i,
      label: $t('银行卡号不能超过19位数字，不低于16位数字')
    },
    axleBase: {
      value: /^[1-9][0-9]{3}$/i,
      label: $t('输入的格式不正确，4位数字')
    },
    supervisory: {
      value: /^[A-Za-z0-9]{1,20}$/i,
      label: $t('格式为：英文大小写，数字，最多支持20个字符')
    },
    threeCode: {
      value: /^[A-Za-z]{3}$/i,
      label: '格式为：3个字符的英文大小写'
    },
    plateNumber: {
      min: 6,
      max: 7,
      message: $t('限6到7个字符内'),
      trigger: ['blur', 'change']
    },
    phoneNumber: {
      value: /^\d{9,16}$/,
      label: $t('请输入9-16位数字')
    },
    presellTime: {
      value: /^[1-9][0-9]{0,1}$/,
      label: $t('数字:1-99')
    },
    stopSellTime: {
      value: /^[1-9][0-9]{0,2}$/,
      label: $t('数字:1-999')
    },
    oneHourTime: {
      value:
        /^((3600)|(3[0-5][0-9]{0,2})|([1-2][0-9]{0,3})|([1-9][0-9]{0,2}))$/,
      label: $t('数字:1-3600')
    },
    maxFourNum: {
      value: /^[1-9][0-9]{0,3}$/,
      label: $t('数字:1-9999')
    },
    maxFiveNum: {
      value: /^[1-9][0-9]{0,4}$/,
      label: $t('数字:1-99999')
    },
    maxFiveNumber: {
      value: /^[0-9][0-9]{0,4}$/,
      label: $t('数字:0-99999')
    },
    amount: {
      value: /^[1-9][0-9]{0,7}$/,
      label: $t('数字:1-99999999')
    },
    weight: {
      value: /^[1-9][0-9]{0,5}$/,
      label: $t('数字:1-999999')
    },
    chargeRate: {
      value: /^[0-9]{1,2}$/,
      label: $t('数字:0-99')
    },
    codeFive: {
      value: /^[0-9A-Za-z]{5}$/,
      label: $t('数字和字母组成，长度为5位')
    },
    codeSix: {
      value: /^[0-9A-Za-z]{6}$/,
      label: $t('数字和字母组成，长度为6位')
    },
    codeEight: {
      value: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8}$/,
      label: $t('数字和字母组成，长度为8位')
    },
    codeTen: {
      value: /^(?=.*[0-9])[a-zA-Z0-9]{1,10}$/,
      label: $t('字母+数字或者纯数字，长度为10个字符及以内')
    },
    codeNineteen: {
      value: /^[0-9a-zA-Z]{0,19}$/,
      label: $t('数字和字母组成，长度为1-19位')
    },
    codeTwenty: {
      value: /^[0-9a-zA-Z_]{1,20}$/,
      label: $t('数字、下划线或字母组成，长度为1-20位')
    },
    connectNumber: {
      value: /^[0-9 -]+$/i,
      label: $t('数字、连接符- 组成')
    },
    enString50: {
      value: /^[a-zA-Z\s]{0,50}$/,
      label: $t('50个英文字符')
    },
    upperCaseNum: {
      value: /^[A-Z_0-9]+$/i,
      label: $t('格式为：英文或数字')
    },
    enString60: {
      value: /^[a-zA-Z\s]{0,60}$/,
      label: $t('60个英文字符')
    },
    latitudeANDlongitude: {
      value: /^((-)?\d{1,3})(\.\d{1,8})?$/,
      label: $t('整数最多3位，小数最多8位')
    },
    number_letter: {
      value: /^[\w]+$/,
      label: $t('只能输入数字、字母或下划线')
    },
    num_Sting15: {
      value: /^[a-zA-Z]{2}\d{13}$|^\d{15}$/,
      label: $t('15位数字或首字母两个+13位数字')
    },
    num_chinese_en: {
      value: /^([\u4e00-\u9fa5A-Za-z0-9]{0,30})$/i,
      label: $t('中文字符/数字/英文，长度为1-30位')
    },
    max160: {
      value: /^([1-9]\d?|1[0-5]\d|160)$/,
      label: $t('1-160之间')
    },
    numOneFloat: {
      value: /^(10|[0-9])(\.[0-9]{1,2})?$/i,
      label: $t('0-10,请精确到两位小数')
    },
    numOneTwo: {
      value: /^(1|2)$/i,
      label: $t('请选择性别')
    },
    numOneInt: {
      value: /^[1-9]{1}$/i,
      label: $t('1-9的整数')
    },
    numOneToFourInt: {
      value: /^(?:[1-9]|([1][0-9])?|2[0-4])$/i,
      label: $t('1-24的整数')
    },
    max99999Int: {
      value: /^[1-9]\d{0,4}$/i,
      label: $t('1-99999的正整数')
    },
    int8lastP: {
      value: /^\d{9}P$/,
      label: $t('9位数字+字母P')
    },
    int0or1: {
      value: /^[01]$/,
      label: $t('限填0或者1')
    },
    int200: {
      value: /^([1-9]|[1-9]\d|1\d{2}|200)$/,
      label: $t('1-200的正整数')
    },
    int2Fload3: {
      value: /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,1}\.\d{0,3}$|^[1-9]\d{0,1}$/,
      label: $t('最大数值为2位整数+3位小数')
    },
    maxOneThousandNum: {
      value: /^(?:\d{1,3}|1000)$/,
      label: $t('最大可输入:1000')
    },
    int15to18: {
      value: /[a -zA -Z]{15,18}/,
      label: $t('请输入15-18位')
    },
    noBlankSpace: {
      value: /^\S*$/,
      label: $t('不能有空格')
    },
    percentFloat: {
      value: /^([1-9][0-9]{0,1}|100)(\.[0-9]{1,2})?$/i,
      label: $t('1-100,请精确到两位小数')
    },
    receiverName: {
      value: /^[A-Za-z\'\.\-\ ]{1,30}$/,
      label: $t("1-30位字母大小写'.- )的组合")
    },
    account: {
      value: /^09[0-9]{2,30}$/,
      label: $t('09开头的数字，最长支持30个字符')
    },
    tenNumDecimal: {
      value: /^\d{0,10}(\.[0-9]{1,3})?$/i,
      label: $t('支持输入10位数字，3位小数')
    },
    int11Fload3: {
      value: /^\d{1,11}(?:\.\d{1,3})?$/,
      label: $t('最大数值为11位整数+3位小数')
    },
    int11Fload2: {
      value: /^\d{1,11}(?:\.\d{1,2})?$/,
      label: $t('最大数值为11位整数+2位小数')
    },
    int14Fload2: {
      value: /^[0-9]{1,10}(\.[0-9]{1,2})?$/,
      label: $t('数字输入，允许2位小数，长度支持13位')
    },
    tenInterAnd2String: {
      value: /^\d{1,10}(\.\d{0,2})?$/,
      label: $t('整数最多10位，小数最多2位')
    },
    tenInterAnd3String: {
      value: /^\d{1,10}(\.\d{0,3})?$/,
      label: $t('整数最多10位，小数最多3位')
    },
    sevenInterAnd3String: {
      value: /^\d{1,7}(\.\d{0,3})?$/,
      label: $t('整数最多7位，小数最多3位')
    },
    int20Fload2: {
      value: /^[0-9]{1,20}(\.[0-9]{1,2})?$/,
      label: $t('数字输入20位，允许2位小数，长度支持23位')
    },
    waybillNoRule: {
      value: /^YDPH.{14}$/,
      label: $t('请输入YDPH开头一共18位的运单号')
    },
    int15Fload2: {
      value: /^[0-9]{1,15}(\.[0-9]{1,2})?$/,
      label: $t('数字输入，允许2位小数，长度支持18位')
    },
    int16Fload3: {
      value: /^[0-9]{1,16}(\.[0-9]{1,3})?$/,
      label: $t('整数输入16位，允许3位小数，长度支持20位')
    },
    int10Fload2: {
      value: /^[0-9]{1,10}(\.[0-9]{1,2})?$/,
      label: $t('整数输入10位，允许2位小数，长度支持13位')
    },
    int999999: {
      value: /^[0-9]{0,6}$/i,
      label: $t('0-999999')
    },
    sixInterAnd2String: {
      value: /^\d{1,6}(\.\d{0,2})?$/,
      label: $t('整数最多6位，小数最多2位')
    },
    NonChinese: {
      value: /^[^\u4e00-\u9fa5]+$/,
      label: $t('不可以输入中文')
    }
  }
};

export function email(rule, value, callback) {
  if (value && !VALIDATION.email.value.test(value)) {
    callback(new Error(VALIDATION.email.label));
  } else {
    callback();
  }
}
// 时间格式效验
export function timeValidator(rule, value, callback) {
  const reg = /^([01]\d|2[0123]):([0-5]\d|60)$/;
  if (value === '' || value === undefined) {
    callback();
  } else {
    if (!reg.test(value)) {
      callback(new Error($t('请输入正确格式，例如23:00或2300')));
    } else {
      callback();
    }
  }
}
// 航班号
export function flightCode(rule, value, callback) {
  if (value && !VALIDATION.flightCode.value.test(value)) {
    callback(new Error(VALIDATION.flightCode.label));
  } else {
    callback();
  }
}

// 1-500的正整数
export function int500(rule, value, callback) {
  if (value && !VALIDATION.int500.value.test(value)) {
    callback(new Error(VALIDATION.int500.label));
  } else {
    callback();
  }
}

// 车牌号
export function vehiclePlateNumber(rule, value, callback) {
  if (value && !VALIDATION.vehiclePlateNumber.value.test(value)) {
    callback(new Error(VALIDATION.vehiclePlateNumber.label));
  } else {
    callback();
  }
}

// 价格
export function priceNum(rule, value, callback) {
  if (value && !VALIDATION.priceNum.value.test(value)) {
    callback(new Error(VALIDATION.priceNum.label));
  } else {
    callback();
  }
}

// 车轴数
export function axleNumber(rule, value, callback) {
  if (value && !VALIDATION.axleNumber.value.test(value)) {
    callback(new Error(VALIDATION.axleNumber.label));
  } else {
    callback();
  }
}
// 0或者1
export function or0and1(rule, value, callback) {
  if (value && !VALIDATION.or0and1.value.test(value)) {
    callback(new Error(VALIDATION.or0and1.label));
  } else {
    callback();
  }
}
// 自有车数量
export function carCount(rule, value, callback) {
  if (value && !VALIDATION.carCount.value.test(value)) {
    callback(new Error(VALIDATION.carCount.label));
  } else {
    callback();
  }
}

// 座机号 + 手机号
export function landlineCellphone(rule, value, callback) {
  if (value && !VALIDATION.landlineCellphone.value.test(value)) {
    callback(new Error(VALIDATION.landlineCellphone.label));
  } else {
    callback();
  }
}

// 银行账号
export function bankNo(rule, value, callback) {
  if (value && !VALIDATION.bankNo.value.test(value)) {
    callback(new Error(VALIDATION.bankNo.label));
  } else {
    callback();
  }
}

// 50个数字
export function fiftyNum(rule, value, callback) {
  if (value && !VALIDATION.fiftyNum.value.test(value)) {
    callback(new Error(VALIDATION.fiftyNum.label));
  } else {
    callback();
  }
}

// 统一社会信用代码
export function reditCode(rule, value, callback) {
  if (value && !VALIDATION.reditCode.value.test(value)) {
    callback(new Error(VALIDATION.reditCode.label));
  } else {
    callback();
  }
}

// 统一社会信用代码
export function int99(rule, value, callback) {
  if (value && !VALIDATION.int99.value.test(value)) {
    callback(new Error(VALIDATION.int99.label));
  } else {
    callback();
  }
}

/* 印尼车牌-校验规则：【1-2位】大写英文字母【1-4位】数字【0-3位】英文字母 */
export function chePlateNumber(rule, value, callback) {
  if (value && !VALIDATION.chePlateNumber.value.test(value)) {
    callback(new Error(VALIDATION.chePlateNumber.label));
  } else {
    callback();
  }
}

/* 手机号-校验规则: 10位数字 */
export function chePhone(rule, value, callback) {
  if (value && !VALIDATION.chePhone.value.test(value)) {
    callback(new Error(VALIDATION.chePhone.label));
  } else {
    callback();
  }
}

/* 输入纯数字 */
export function isPureNumber(rule, value, callback) {
  if (value && !VALIDATION.pureNumber.value.test(value)) {
    callback(new Error(VALIDATION.pureNumber.label));
  } else {
    callback();
  }
}

export function mileage(rule, value, callback) {
  if (value && !VALIDATION.mileage.value.test(value)) {
    callback(new Error(VALIDATION.mileage.label));
  } else {
    callback();
  }
}

export function num11(rule, value, callback) {
  if (value && !VALIDATION.num11.value.test(value)) {
    callback(new Error(VALIDATION.num11.label));
  } else {
    callback();
  }
}

export function moneyNumber2(rule, value, callback) {
  if (value && !VALIDATION.moneyNumber2.value.test(value)) {
    callback(new Error(VALIDATION.moneyNumber2.label));
  } else {
    callback();
  }
}
export function codeStrikeGang(rule, value, callback) {
  if (value && !VALIDATION.codeStrikeGang.value.test(value)) {
    callback(new Error(VALIDATION.codeStrikeGang.label));
  } else {
    callback();
  }
}

export function priceEightTwo(rule, value, callback) {
  if (value && !VALIDATION.priceEightTwo.value.test(value)) {
    callback(new Error(VALIDATION.priceEightTwo.label));
  } else {
    callback();
  }
}

// 数字 小数后两位
export function numTwo(rule, value, callback) {
  if (value && !VALIDATION.numTwo.value.test(value)) {
    callback(new Error(VALIDATION.numTwo.label));
  } else {
    callback();
  }
}

export function tenNumberCode(rule, value, callback) {
  if (value && !VALIDATION.tenNumberCode.value.test(value)) {
    callback(new Error(VALIDATION.tenNumberCode.label));
  } else {
    callback();
  }
}

// 整数20位 小数2位
export function twentyVits2(rule, value, callback) {
  if (value && !VALIDATION.twentyVits2.value.test(value)) {
    callback(new Error(VALIDATION.twentyVits2.label));
  } else {
    callback();
  }
}

export function numSix(rule, value, callback) {
  if (value && !VALIDATION.numSix.value.test(value)) {
    callback(new Error(VALIDATION.numSix.label));
  } else {
    callback();
  }
}

export function nineNum(rule, value, callback) {
  if (value && !VALIDATION.nineNum.value.test(value)) {
    callback(new Error(VALIDATION.nineNum.label));
  } else {
    callback();
  }
}

export function tenNum(rule, value, callback) {
  if (value && !VALIDATION.tenNum.value.test(value)) {
    callback(new Error(VALIDATION.tenNum.label));
  } else {
    callback();
  }
}

/**
 * @desc 8为数字+字母P
 */
export function int8lastP(rule, value, callback) {
  if (value && !VALIDATION.int8lastP.value.test(value)) {
    callback(new Error(VALIDATION.int8lastP.label));
  } else {
    callback();
  }
}

export function twentyNum(rule, value, callback) {
  if (value && !VALIDATION.twentyNum.value.test(value)) {
    callback(new Error(VALIDATION.twentyNum.label));
  } else {
    callback();
  }
}

export function thirtyNum(rule, value, callback) {
  if (value && !VALIDATION.thirtyNum.value.test(value)) {
    callback(new Error(VALIDATION.thirtyNum.label));
  } else {
    callback();
  }
}
/**
 * @desc 1-99999的正整数
 */
export function max99999Int(rule, value, callback) {
  if (value && !VALIDATION.max99999Int.value.test(value)) {
    callback(new Error(VALIDATION.max99999Int.label));
  } else {
    callback();
  }
}

/**
 * @desc 1位1-2的整数，限制性别
 */
export function numOneTwo(rule, value, callback) {
  if (!VALIDATION.numOneTwo.value.test(value)) {
    callback(new Error(VALIDATION.numOneTwo.label));
  } else {
    callback();
  }
}

/**
 * @desc 1位1-24的整数
 */
export function numOneToFourInt(rule, value, callback) {
  if (value && !VALIDATION.numOneToFourInt.value.test(value)) {
    callback(new Error(VALIDATION.numOneToFourInt.label));
  } else {
    callback();
  }
}

/**
 * @desc 1位0-9的整数
 */
export function numOneInt(rule, value, callback) {
  if (value && !VALIDATION.numOneInt.value.test(value)) {
    callback(new Error(VALIDATION.numOneInt.label));
  } else {
    callback();
  }
}

/**
 * @desc 4整数2小数
 */
export function int4Fload2(rule, value, callback) {
  if (value && !VALIDATION.int4Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int4Fload2.label));
  } else {
    callback();
  }
}
/**
 * @desc 2整数2小数
 */
export function int2Fload2(rule, value, callback) {
  if (value && !VALIDATION.int2Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int2Fload2.label));
  } else {
    callback();
  }
}
/**
 * @desc 5整数2小数
 */
export function int5Fload2(rule, value, callback) {
  if (value && !VALIDATION.int5Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int5Fload2.label));
  } else {
    callback();
  }
}
/**
 * @desc 6整数2小数
 */
export function int6Fload2(rule, value, callback) {
  if (value && !VALIDATION.int6Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int6Fload2.label));
  } else {
    callback();
  }
}
/**
 * @desc 支付密码
 */
export function payPass(rule, value, callback) {
  if (value && !VALIDATION.payPass.value.test(value)) {
    callback(new Error(VALIDATION.payPass.label));
  } else {
    callback();
  }
}
/**
 * @desc 车票
 */
export function carNumber(rule, value, callback) {
  if (value && !VALIDATION.carNumber.value.test(value)) {
    callback(new Error(VALIDATION.carNumber.label));
  } else {
    callback();
  }
}
/**
 * @desc 4个字符没得数字
 */
export function carNum(rule, value, callback) {
  if (value && !VALIDATION.carNum.value.test(value)) {
    callback(new Error(VALIDATION.carNum.label));
  } else {
    callback();
  }
}
/**
 * @desc 8个字符没得数字
 */
export function eightNum(rule, value, callback) {
  if (value && !VALIDATION.eightNum.value.test(value)) {
    callback(new Error(VALIDATION.eightNum.label));
  } else {
    callback();
  }
}

// @desc 权限名称30个中文字符/数字/英文
export function num_chinese_en(rule, value, callback) {
  if (value && !VALIDATION.num_chinese_en.value.test(value)) {
    callback(new Error(VALIDATION.num_chinese_en.label));
  } else {
    callback();
  }
}

// @desc 校验单号规则
export function num_Sting15(rule, value, callback) {
  if (value && !VALIDATION.num_Sting15.value.test(value)) {
    callback(new Error(VALIDATION.num_Sting15.label));
  } else {
    callback();
  }
}
/**
 * @desc 表单验证集合
 */

// 经度 纬度 非必填 正负数，-123.12345678
export function latitudeANDlongitude(rule, value, callback) {
  if (value && !VALIDATION.latitudeANDlongitude.value.test(value)) {
    callback(new Error(VALIDATION.latitudeANDlongitude.label));
  } else {
    callback();
  }
}
// 数字 非必填
export function isNumber(rule, value, callback) {
  if (value && Number.isNaN(Number(value))) {
    callback(new Error($t('请输入数字')));
  } else {
    callback();
  }
}
//  非全部数字
export function noNumber(rule, value, callback) {
  if (value && !Number.isNaN(Number(value))) {
    callback(new Error($t('不能纯数字')));
  } else {
    callback();
  }
}
//  0/正整数
export function integer(rule, value, callback) {
  if (value && !VALIDATION.integer.value.test(value)) {
    callback(new Error(VALIDATION.integer.label));
  } else {
    callback();
  }
}
//  数字可以是负数
export function negative(rule, value, callback) {
  if (value && !VALIDATION.negative.value.test(value)) {
    callback(new Error(VALIDATION.negative.label));
  } else {
    callback();
  }
}
//  0/正整数
export function decimalLessthanOne(rule, value, callback) {
  if (value && value >= 1) {
    callback(new Error($t('不能大于1')));
  } else {
    callback();
  }
}
//  0/正整数
export function integer99999999999(rule, value, callback) {
  if (value && value > 99999999999) {
    callback(new Error(new Error($t('上限11位'))));
  } else {
    callback();
  }
}
//  大于0正整数
export function moreZeroInteger(rule, value, callback) {
  if (value && !VALIDATION.moreZeroInteger.value.test(value)) {
    callback(new Error(VALIDATION.moreZeroInteger.label));
  } else {
    callback();
  }
}
//  大于0保留两位小数
export function floatingNum(rule, value, callback) {
  const val = Number(value);
  if (
    (val === 0 && value !== '') ||
    (value && !VALIDATION.floatingNum.value.test(value))
  ) {
    callback(new Error(VALIDATION.floatingNum.label));
  } else {
    callback();
  }
}

export function requestNumber(rule, value, callback) {
  if (value && !VALIDATION.requestNumber.value.test(value)) {
    callback(new Error(VALIDATION.requestNumber.label));
  } else {
    callback();
  }
}
export function numberAndString(rule, value, callback) {
  if (value && !VALIDATION.numberAndString.value.test(value)) {
    callback(new Error(VALIDATION.numberAndString.label));
  } else {
    callback();
  }
}
// 字符和数字 非必填
export function isStringNumber(rule, value, callback) {
  if (value && !VALIDATION.code.value.test(value)) {
    callback(new Error(VALIDATION.code.label));
  } else {
    callback();
  }
}
// 字母大写或数字
export function upperCaseNum(rule, value, callback) {
  if (value && !VALIDATION.upperCaseNum.value.test(value)) {
    callback(new Error(VALIDATION.upperCaseNum.label));
  } else {
    callback();
  }
}
// 3个字符的大小写英文
export function threeCode(rule, value, callback) {
  if (value) {
    if (!VALIDATION.threeCode.value.test(value)) {
      callback(new Error(VALIDATION.threeCode.label));
    } else {
      callback();
    }
  } else {
    callback();
  }
}
// 邮编验证
export function zipcode(rule, value, callback) {
  if (value) {
    if (!VALIDATION.zipcode.value.test(value)) {
      callback(new Error(VALIDATION.zipcode.label));
    } else {
      callback();
    }
  } else {
    callback();
  }
}
// 区号
export function areaNo(rule, value, callback) {
  if (value) {
    if (!VALIDATION.areaNo.value.test(value)) {
      callback(new Error(VALIDATION.areaNo.label));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 数字 和 连接符-  非必填
export function connectNumber(rule, value, callback) {
  if (value && !VALIDATION.connectNumber.value.test(value)) {
    callback(new Error(VALIDATION.connectNumber.label));
  } else {
    callback();
  }
}
// 数字 小数后两位
export function numTwoFloat(rule, value, callback) {
  if (value && !VALIDATION.numTwoFloat.value.test(value)) {
    callback(new Error(VALIDATION.numTwoFloat.label));
  } else {
    callback();
  }
}
// 验证密码
export function checkPass(rule, value, callback) {
  if (value.length < 6) {
    callback(new Error($t('不能小于6位')));
  }
  if (value.length > 11) {
    callback(new Error($t('不能超过11位')));
  } else {
    callback();
  }
}
// email邮箱格式校验
export function emailPhone(rule, value, callback) {
  if (!VALIDATION.email.value.test(value)) {
    callback(new Error(VALIDATION.email.label));
  } else {
    callback();
  }
}

// email邮箱格式校验可以为空
export function emailPhoneNull(rule, value, callback) {
  if (
    (value && !VALIDATION.email.value.test(value)) ||
    (value === 0 && !VALIDATION.email.value.test(value))
  ) {
    callback(new Error(VALIDATION.email.label));
  } else {
    callback();
  }
}

// 编码检验
export function codeName(rule, value, callback) {
  if (!VALIDATION.codeName.value.test(value)) {
    callback(new Error(VALIDATION.codeName.label));
  } else {
    callback();
  }
}
export function codeName15(rule, value, callback) {
  if (!VALIDATION.codeName15.value.test(value)) {
    callback(new Error(VALIDATION.codeName15.label));
  } else {
    callback();
  }
}
// 英文名称
export function enString(rule, value, callback) {
  if (value) {
    if (!VALIDATION.enString.value.test(value)) {
      callback(new Error(VALIDATION.enString.label));
    } else {
      callback();
    }
  } else {
    callback();
  }
}
// 中文英文数字名称
export function chEnNumString(rule, value, callback) {
  if (value) {
    if (!VALIDATION.chEnNumString.value.test(value)) {
      callback(new Error(VALIDATION.chEnNumString.label));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 50英文名称
export function enString50(rule, value, callback) {
  if (value) {
    if (!VALIDATION.enString50.value.test(value)) {
      callback(new Error(VALIDATION.enString50.label));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 60英文名称
export function enString60(rule, value, callback) {
  if (value) {
    if (!VALIDATION.enString60.value.test(value)) {
      callback(new Error(VALIDATION.enString60.label));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 中文名称
export function chString(rule, value, callback) {
  if (value) {
    if (!VALIDATION.chString.value.test(value)) {
      callback(new Error(VALIDATION.chString.label));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 5位类型编码
export function codeFive(rule, value, callback) {
  if (!VALIDATION.codeFive.value.test(value)) {
    callback(new Error(VALIDATION.codeFive.label));
  } else {
    callback();
  }
}
// 6位类型编码
export function codeSix(rule, value, callback) {
  if (!VALIDATION.codeSix.value.test(value)) {
    callback(new Error(VALIDATION.codeSix.label));
  } else {
    callback();
  }
}

// 5位类型编码
export function codeEight(rule, value, callback) {
  if (!VALIDATION.codeEight.value.test(value)) {
    callback(new Error(VALIDATION.codeEight.label));
  } else {
    callback();
  }
}

// 10位类型编码
export function codeTen(rule, value, callback) {
  if (!VALIDATION.codeTen.value.test(value)) {
    callback(new Error(VALIDATION.codeTen.label));
  } else {
    callback();
  }
}
// 数字、字母、下划线
export function number_letter(rule, value, callback) {
  if (!VALIDATION.number_letter.value.test(value)) {
    callback(new Error(VALIDATION.number_letter.label));
  } else {
    callback();
  }
}
// 20位字典类型编码
export function codeTwenty(rule, value, callback) {
  if (!VALIDATION.codeTwenty.value.test(value)) {
    callback(new Error(VALIDATION.codeTwenty.label));
  } else {
    callback();
  }
}

// 19位字典类型编码
export function codeNineteen(rule, value, callback) {
  if (!VALIDATION.codeNineteen.value.test(value)) {
    callback(new Error(VALIDATION.codeNineteen.label));
  } else {
    callback();
  }
}

// 20位字典类型编码
export function bankCard(rule, value, callback) {
  if (!VALIDATION.bankCard.value.test(value)) {
    callback(new Error(VALIDATION.bankCard.label));
  } else {
    callback();
  }
}

// 大于0的数字
export function moreZeroFloat(rule, value, callback) {
  if (!VALIDATION.moreZeroFloat.value.test(value)) {
    callback(new Error(VALIDATION.moreZeroFloat.label));
  } else {
    callback();
  }
}

// 999以内数字
export function stopSellTime(rule, value, callback) {
  if (!VALIDATION.stopSellTime.value.test(value) && value) {
    callback(new Error(VALIDATION.stopSellTime.label));
  } else {
    callback();
  }
}
// 3600以内数字
export function oneHourTime(rule, value, callback) {
  if (!VALIDATION.oneHourTime.value.test(value) && value) {
    callback(new Error(VALIDATION.oneHourTime.label));
  } else {
    callback();
  }
}
// 日期 时分秒
export function time(rule, value, callback) {
  if (!VALIDATION.time.value.test(value) && value) {
    callback(new Error(VALIDATION.time.label));
  } else {
    callback();
  }
}
// 99以内数字
export function maxOneNum(rule, value, callback) {
  if (!VALIDATION.maxOneNum.value.test(value)) {
    callback(new Error(VALIDATION.maxOneNum.label));
  } else {
    callback();
  }
}
// 99以内数字
export function maxTwoNum(rule, value, callback) {
  if (value && !VALIDATION.coupon.value.test(value)) {
    callback(new Error(VALIDATION.coupon.label));
  } else {
    callback();
  }
}

// 9999以内数字
export function maxFourNum(rule, value, callback) {
  if (value && !VALIDATION.maxFourNum.value.test(value)) {
    callback(new Error(VALIDATION.maxFourNum.label));
  } else {
    callback();
  }
}

// 99999以内数字
export function maxFiveNum(rule, value, callback) {
  if (value && !VALIDATION.maxFiveNum.value.test(value)) {
    callback(new Error(VALIDATION.maxFiveNum.label));
  } else {
    callback();
  }
}
// 99999以内数字
export function maxFiveNumber(rule, value, callback) {
  if (!VALIDATION.maxFiveNumber.value.test(value) && value.trim()) {
    callback(new Error(VALIDATION.maxFiveNumber.label));
  } else {
    callback();
  }
}
export function maxFiveAndTenThousand(rule, value, callback) {
  if (value > 10000 || value < 5000) {
    callback(new Error($t('数字:5000-10000')));
  } else {
    callback();
  }
}

export function max99999(rule, value, callback) {
  if (value > 99999) {
    callback(new Error($t('数字:最大99999')));
  } else {
    callback();
  }
}
export function max9999999(rule, value, callback) {
  if (value > 9999999 || value <= 0) {
    callback(new Error('数字:1-9999999'));
  } else {
    callback();
  }
}
export function max1000000000(rule, value, callback) {
  if (value > 1000000000 || value < 0) {
    callback(new Error('最大输入9位数'));
  } else {
    callback();
  }
}

// 160以内数字运力速度
export function max160(rule, value, callback) {
  if (!VALIDATION.max160.value.test(value)) {
    callback(new Error(VALIDATION.max160.label));
  } else {
    callback();
  }
}
// 0-10，保留两位小数
export function numOneFloat(rule, value, callback) {
  if (!VALIDATION.numOneFloat.value.test(value)) {
    callback(new Error(VALIDATION.numOneFloat.label));
  } else {
    callback();
  }
}
// 只能填 0 or 1
export function int0or1(rule, value, callback) {
  if (value && !VALIDATION.int0or1.value.test(value)) {
    callback(new Error(VALIDATION.int0or1.label));
  } else {
    callback();
  }
}

// 1-200的正整数
export function int200(rule, value, callback) {
  if (value && !VALIDATION.int200.value.test(value)) {
    callback(new Error(VALIDATION.int200.label));
  } else {
    callback();
  }
}
// 0-1000数字
export function maxOneThousandNum(rule, value, callback) {
  if (!VALIDATION.maxOneThousandNum.value.test(value)) {
    callback(new Error(VALIDATION.maxOneThousandNum.label));
  } else {
    callback();
  }
}

/**
 * 两个关联input必填校验
 * @param { String } relationInputName 关联表单元素的prop
 * @param { String } form 表单在this.data里面的key
 * @param { String } formRefName 元素所在表单的ref名称
 * @param { String } message 为空提示语
 * @param { Object } self this指针
 */
export const inputRelationValiHandle = (
  relationInputName,
  form,
  formRefName,
  message,
  self
) => {
  // 返回标准的自定义校验函数
  return (rule, value, callback) => {
    // 当前表单元素值为空
    if (!value) {
      // 关联表单元素的值不为空
      if (self[form][relationInputName]) {
        callback();
      } else {
        // 提示异常
        callback(new Error($t(message)));
      }
    } else {
      // 关联表单元素的值不为空
      if (self[form][relationInputName]) {
        callback();
      } else {
        // 校验关联表单元素
        self.$refs[formRefName].validateField(relationInputName);
        callback();
      }
    }
  };
};

// 限制数字不超过30
export function limitNumber30(rule, value, callback) {
  if (value && value > VALIDATION.limitNumber30.value) {
    callback(new Error(VALIDATION.limitNumber30.label));
  } else {
    callback();
  }
}

/**
 * @desc 2整数3小数
 */
export function int2Fload3(rule, value, callback) {
  if (value && !VALIDATION.int2Fload3.value.test(value)) {
    callback(new Error(VALIDATION.int2Fload3.label));
  } else {
    callback();
  }
}
/**
 * @desc 15-18位
 */
export function int15to18(rule, value, callback) {
  if (value && !VALIDATION.int15to18.value.test(value)) {
    callback(new Error(VALIDATION.int15to18.label));
  } else {
    callback();
  }
}
// 不能有空格
export function noBlankSpace(rule, value, callback) {
  if (!VALIDATION.noBlankSpace.value.test(value)) {
    callback(new Error(VALIDATION.noBlankSpace.label));
  } else {
    callback();
  }
}

// 0-99，保留两位小数
export function percentFloat(rule, value, callback) {
  if (value && !VALIDATION.percentFloat.value.test(value)) {
    callback(new Error(VALIDATION.percentFloat.label));
  } else {
    callback();
  }
}

export function receiverName(rule, value, callback) {
  if (value && !VALIDATION.receiverName.value.test(value)) {
    callback(new Error(VALIDATION.receiverName.label));
  } else {
    callback();
  }
}
export function account(rule, value, callback) {
  if (value && !VALIDATION.account.value.test(value)) {
    callback(new Error(VALIDATION.account.label));
  } else {
    callback();
  }
}

export function tenNumDecimal(rule, value, callback) {
  if (value && !VALIDATION.tenNumDecimal.value.test(value)) {
    callback(new Error(VALIDATION.tenNumDecimal.label));
  } else {
    callback();
  }
}

export function int11Fload3(rule, value, callback) {
  if (value && !VALIDATION.int11Fload3.value.test(value)) {
    callback(new Error(VALIDATION.int11Fload3.label));
  } else {
    callback();
  }
}

export function int15Fload2(rule, value, callback) {
  if (value && !VALIDATION.int15Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int15Fload2.label));
  } else {
    callback();
  }
}

export function int11Fload2(rule, value, callback) {
  if (value && !VALIDATION.int11Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int11Fload2.label));
  } else {
    callback();
  }
}
export function int20Fload2(rule, value, callback) {
  if (value && !VALIDATION.int20Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int20Fload2.label));
  } else {
    callback();
  }
}

export function int14Fload2(rule, value, callback) {
  if (value && !VALIDATION.int14Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int14Fload2.label));
  } else {
    callback();
  }
}

export function tenInterAnd2String(rule, value, callback) {
  if (value && !VALIDATION.tenInterAnd2String.value.test(value)) {
    callback(new Error(VALIDATION.tenInterAnd2String.label));
  } else {
    callback();
  }
}
export function tenInterAnd3String(rule, value, callback) {
  if (value && !VALIDATION.tenInterAnd3String.value.test(value)) {
    callback(new Error(VALIDATION.tenInterAnd3String.label));
  } else {
    callback();
  }
}
export function sevenInterAnd3String(rule, value, callback) {
  if (value && !VALIDATION.sevenInterAnd3String.value.test(value)) {
    callback(new Error(VALIDATION.sevenInterAnd3String.label));
  } else {
    callback();
  }
}

export function waybillNoRule(rule, value, callback) {
  if (value && !VALIDATION.waybillNoRule.value.test(value)) {
    callback(new Error(VALIDATION.waybillNoRule.label));
  } else {
    callback();
  }
}

export function int16Fload3(rule, value, callback) {
  if (value && !VALIDATION.int16Fload3.value.test(value)) {
    callback(new Error(VALIDATION.int16Fload3.label));
  } else {
    callback();
  }
}
export function int10Fload2(rule, value, callback) {
  if (value && !VALIDATION.int10Fload2.value.test(value)) {
    callback(new Error(VALIDATION.int10Fload2.label));
  } else {
    callback();
  }
}
export function int999999(rule, value, callback) {
  if (value && !VALIDATION.int999999.value.test(value)) {
    callback(new Error(VALIDATION.int999999.label));
  } else {
    callback();
  }
}
export function sixInterAnd2String(rule, value, callback) {
  if (value && !VALIDATION.sixInterAnd2String.value.test(value)) {
    callback(new Error(VALIDATION.sixInterAnd2String.label));
  } else {
    callback();
  }
}

export function NonChinese(rule, value, callback) {
  if (value && !VALIDATION.NonChinese.value.test(value)) {
    callback(new Error(VALIDATION.NonChinese.label));
  } else {
    callback();
  }
}
